import { VerificationRequestType } from 'src/api';
import type { SelectFieldOption } from 'src/types/components';

export enum VerificationRequestCreateFormFields {
  ssn = 'ssn',
  employeeFirstName = 'employeeFirstName',
  employeeLastName = 'employeeLastName',
  employeeDateOfBirth = 'employeeDateOfBirth',
  verificationReportType = 'verificationReportType',
  permissiblePurposeId = 'permissiblePurposeId',
  noteToEmployee = 'noteToEmployee',
  paymentMethod = 'paymentMethod',
  employers = 'employers',
  error = 'error',
}

export const VERIFICATION_REQUEST_TYPE_SHORT_LABEL: Record<VerificationRequestType, string> = {
  [VerificationRequestType.VerificationOfIncome]: 'VoI',
  [VerificationRequestType.VerificationOfEmployment]: 'VoE',
  [VerificationRequestType.GovernmentalVerification]: 'GSSV',
};

export const VERIFICATION_REQUEST_TYPE_LABEL: Record<VerificationRequestType, string> = {
  [VerificationRequestType.VerificationOfIncome]: 'Verification Of Income',
  [VerificationRequestType.VerificationOfEmployment]: 'Verification Of Employment',
  [VerificationRequestType.GovernmentalVerification]: 'Government/Social Services Verification',
};

export const governmentVerificationRequestTypeOptions = Object.values(VerificationRequestType)
  .filter(option => option === VerificationRequestType.GovernmentalVerification)
  .map(value => ({
    value,
    label: VERIFICATION_REQUEST_TYPE_LABEL[value],
  })) satisfies SelectFieldOption[];

export const commercialVerificationRequestTypeOptions = Object.values(VerificationRequestType)
  .filter(option => option !== VerificationRequestType.GovernmentalVerification)
  .map(value => ({
    value,
    label: VERIFICATION_REQUEST_TYPE_LABEL[value],
  })) satisfies SelectFieldOption[];

export const cvStaffVerificationsRequestTypeOptions = Object.values(VerificationRequestType).map(
  value => ({ value, label: VERIFICATION_REQUEST_TYPE_LABEL[value] }),
) satisfies SelectFieldOption[];

export const cvStaffTestVerificationsRequestTypeOptions = Object.values(
  VerificationRequestType,
).map(value => ({
  value,
  label: VERIFICATION_REQUEST_TYPE_LABEL[value],
})) satisfies SelectFieldOption[];
